import { Grid, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material'
import React from 'react'
import '../../../ArticlePage.css'
import CircleIcon from '@mui/icons-material/Circle';


const TravelAndHospitality = () => {

    const useCaseData = [
        {
            title: 'Food and Hospitality: Reservation Management and Order Processing',
            content: "For the travel industry, conversational AI chatbots assist with booking flights, hotels, and rental cars, all while offering real-time updates on delays or itinerary changes. These bots can even provide personalized travel recommendations, making them a valuable tool for both business and leisure travelers.",
            ussagePoints: [
                'Assisting customers with flight, hotel, or car rental bookings',
                'Sending real-time updates on flight status, check-in details, or travel disruptions',
                'Answering questions about destination requirements, like visa or health protocols',
            ]
        },
    ]

    return (
        <>
            {useCaseData.map((ele, index) => {
                const useCaseIdx = index + 1
                return (
                    <>
                        <Grid item xs={12} sx={{ margin: "10px 0px" }}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={12} sx={{ mb: '30px' }}>
                                            <Typography
                                                component='span'
                                                className='artical-paragraph-global-text'
                                            >
                                                {ele.content}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <Grid container>
                                                <Grid item xs={12} className='arp-paragraph-global-text-item'>
                                                    <Typography
                                                        variant='span'
                                                        sx={{ fontSize: '16px', fontWeight: '600', color: 'black' }}
                                                    >
                                                        Comman uses:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} className='arp-paragraph-global-text-item'>
                                                    {ele?.ussagePoints?.map((points) => {
                                                        return (
                                                            <>
                                                                <Grid container sx={{ marginLeft: '20px' }}>
                                                                    <Grid item xs={12}>
                                                                        <Grid container sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                                                                            <Grid item sx={{ maxWidth: '15px' }}>
                                                                                <CircleIcon style={{ width: '10px', height: 'auto' }} fontSize="small" />
                                                                            </Grid>
                                                                            <Grid item sx={{ maxWidth: "calc(100% - 20px)", width: "calc(100% - 15px)" }}>
                                                                                <Typography
                                                                                    variant='span'
                                                                                    sx={{ fontSize: '14px', fontWeight: '500', color: 'black' }}
                                                                                >
                                                                                    {points}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>

                                                            </>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                )
            })}
        </>
    )
}

export default TravelAndHospitality